import { useEffect } from 'react';
import { Navigate, Outlet, matchPath, useLocation } from 'react-router-dom';

import { ContentWithStickyHeader } from '@sorare/core/src/atoms/layout/ContentWithStickyHeader';
import {
  MLB_MARKET_COMMON_MARKET,
  MLB_MARKET_COMMON_MARKET_ADD_CARD,
} from '@sorare/core/src/constants/__generated__/routes';

import { CommonMarketHeader } from '@sorare/marketplace/src/components/commonCard/CommonMarketHeader';

import { useMLBEvents } from '@sorare/gameplay/src/lib/events';

const MLBCommonMarketLayout = () => {
  const track = useMLBEvents();
  const location = useLocation();

  useEffect(() => {
    track('View Common Market');
  }, [track]);

  if (matchPath(location.pathname, MLB_MARKET_COMMON_MARKET)) {
    return <Navigate to={MLB_MARKET_COMMON_MARKET_ADD_CARD} replace />;
  }
  return (
    <ContentWithStickyHeader header={<CommonMarketHeader />}>
      <Outlet />
    </ContentWithStickyHeader>
  );
};

export default MLBCommonMarketLayout;
